if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.form.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {

      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');

      const formData = new FormData(this.form);
      let sections = 'cart-icon-bubble';
      if (this.cartDrawer) {
        sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
      }

      formData.append('sections_url', window.location.pathname);
      formData.append('sections', sections);

      const fetchRequestOpts = {
        method: 'POST',
        headers: {
          Accept: 'application/javascript',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: formData
      };

      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        const data = await response.json();
        let error = typeof data.description === 'string' ? data.description : data.message;
        if (data.errors && typeof data.errors === 'object') {
          error = Object.entries(data.errors).map((item) => item[1].join(', '));
        }

        // Show error message if there's an error, but don't block cart drawer opening
        if (data.status) {
          this.setErrorMsgState(error);
          
          // If there was an error, fetch fresh cart data to ensure we have the current cart state
          try {
            const freshCartResponse = await fetch(`${theme.routes.cart}.js`);
            if (freshCartResponse.ok) {
              const freshCartData = await freshCartResponse.json();
              // Merge fresh cart data with the response data
              data.items = freshCartData.items;
              data.item_count = freshCartData.item_count;
              data.total_price = freshCartData.total_price;
            }
          } catch (cartError) {
            console.warn('Failed to fetch fresh cart data:', cartError);
          }
        }

        // Only throw error if the HTTP response itself failed (but not for business logic errors like quantity limits)
        if (!response.ok && response.status !== 422) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {

          // Update cart icon count.
          ProductForm.updateCartIcon(data);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              // Use the theme's built-in cart refresh system instead of manual renderContents
              // This works better with third-party apps that might interfere with sections API
              document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
                bubbles: true
              }));
              
              // Open the cart drawer if it's enabled in theme settings
              if (theme.settings.afterAtc === 'drawer') {
                document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
              }
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
         let operateSetting = $('.overallContent').attr('data-switch');
        if (operateSetting === 'true') {
        let variantValue = data.variant_id;
        let odooInv = Number($(evt.target).find('.product-formAdd-button').attr('data-odoo'));
        let amzInv = Number($(evt.target).find('.product-formAdd-button').attr('data-amz'));
        let inputValue = Number($(evt.target).find('.quantity_products').val());
        // 获取stockType的值
        const invIdentification = localStorage.getItem('stockType');
        // 获取 localStorage 中的 'controlTmark' 的值
        const addTmark = localStorage.getItem('controlTmark');

        // 判断 'controlTmark' 是否存在
        if (addTmark === null || invIdentification == '0') {
          // 如果 'controlTmark' 不存在，或者 'stockType' 为 '0'
          // 则将 'variantValue' 的值添加到 localStorage 中
          localStorage.setItem('controlTmark', variantValue);
        }
        if (invIdentification == '0') {
             
              if (odooInv > inputValue && amzInv > inputValue) {
                  localStorage.setItem('stockType', 0);
                  Inventory.updateAttr("all");
          
              } else if (odooInv >= inputValue && amzInv < inputValue) {
                  localStorage.setItem('stockType', 1);
                  Inventory.updateAttr("odoo");
          
              } else if (amzInv >= inputValue && odooInv < inputValue) {
                  localStorage.setItem('stockType', 2);
                  Inventory.updateAttr("fba");
              }
          }
        Inventory.fetchProductData(variantValue, inputValue, false);
        $(evt.target).find('.quantity_products').val(1);
       }
        
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }

    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');

      if (cartIconBubble && response.sections && response.sections['cart-icon-bubble']) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }

    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) {
        this.errorMsg.innerHTML = '';
        const errorArray = Array.isArray(error) ? error : [error];
        errorArray.forEach((err, index) => {
          if (index > 0) this.errorMsg.insertAdjacentHTML('beforeend', '<br>');
          this.errorMsg.insertAdjacentText('beforeend', err);
        });
      }
    }
  }

  customElements.define('product-form', ProductForm);
}
